module.exports = __webpack_public_path__ + "static/media/Delibird_gaussian2.eaa68b9f.png";